var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download_svg__\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".download_svg__st0,.download_svg__st2{fill:none}.download_svg__st2{stroke:#12a3f8;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.03 3h4C7.6 4.87 8.79 5.41 11 5.41l10.96-.01s.04.03.04.11V20.9c0 .06-.02.09-.02.1l-19.94.01S2 20.98 2 20.9V3.1c0-.06.02-.09.03-.1M2 1C.89 1 0 1.94 0 3.1v17.8C0 22.06.9 23 2 23h20c1.11 0 2-.94 2-2.1V5.51c0-1.16-.9-2.1-2-2.1H11c-1.63 0-2.3-.17-4-2.41H2z",
    style: {
      fill: "#a9aaab"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__st2",
    d: "M7 16v2h10v-2M9 13l3 3 3-3M12 8v7"
  })));
};
export default SvgDownload;